import { GlobalToken, Modal } from 'antd';
import styled from 'styled-components';
import { breakpoints } from '@/utils/util-breakpoints';

export const StyledModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  && {
    top: 0;
    margin: 0;
    padding: 0;
    max-width: 100vw;
  }

  .ant-modal-content {
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    height: 100vh;
    width: 100vw;
    margin: 0;
    top: 0;
    padding: 0;
    position: fixed;
    overflow: auto;

    @media (min-width: ${breakpoints.xl}px) {
      width: calc(100vw - 60px);
      margin-left: 60px;
    }
  }

  .ant-modal-body {
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: ${({ theme: { token } }) => token.colorBgLayout};
    overflow-y: auto;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .ant-modal-close {
    top: ${({ theme: { token } }) => token.padding}px;
    right: ${({ theme: { token } }) => token.padding}px;
    z-index: 2;
  }

  .ant-modal-close-x {
    color: ${({ theme: { token } }) => token.colorTextLightSolid};
  }

  &.site-survey-modal-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;

    .ant-modal {
      padding: 0;
      margin: 0;
      top: 0;
      height: 100vh;
      width: 100vw;
      max-width: 100vw;
    }

    .ant-modal-content {
      height: 100vh;
      border-radius: 0;
      color: ${({ theme: { token } }) => token.colorTextLightSolid};
      display: flex;
      flex-direction: column;
      overflow: auto;

      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .close-icon {
    color: ${({ theme: { token } }) => token.colorTextLightSolid};
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .form-container-wrapper {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    margin-top: 0;
    overflow-y: auto;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .form-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    box-sizing: border-box;
    min-height: fit-content;
    margin: 0;
    height: 100%;

    @media (min-width: ${breakpoints.lg}px) {
      padding: 0;
    }
  }

  .spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-spin {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  }
`;
